var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoleDefinitions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15.889,
    viewBox: "0 0 16 15.889",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m10.5 6.455 2 4.965M3.5 11.42l2-4.965M11.5 13.406h-7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.5,
    cy: 13.406,
    rx: 2,
    ry: 1.983
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5,
    cy: 13.406,
    rx: 2,
    ry: 1.983
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.023.534 3.474 1.387c-.015 1.608-.059 2.904-.664 4.026-.484.899-1.336 1.672-2.791 2.426-1.5-.832-2.42-1.617-2.94-2.574-.56-1.03-.654-2.246-.582-3.873C6.33 1.19 7.497.726 8.023.534z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.419 4.254 1.144.938 2.085-1.865"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleDefinitions);
export default __webpack_public_path__ + "static/media/role-definitions.9ffc4ca5ea75f0d32dc371e41a26d531.svg";
export { ForwardRef as ReactComponent };